<div [ngClass]="isExpanded ? 'attached-drawer' : 'attached-drawer-collapsed'" *ngIf="details != null">
  <div class="drawer-header">
    <span class="drawer-title">{{ label | translate }}</span>
    <button type="button" pButton icon="pi pi-times" class="p-button-rounded p-button-text" (click)="onClose()"></button>
  </div>

  <div class="drawer-content">
    <ng-container *ngIf="!details.isImage">
        <p style="white-space: pre-wrap;">{{ details.phraseTxt }}</p>
    </ng-container>

      <ng-container *ngIf="details.isImage">
        <async-img [url]="details.url" alt="Drawer Image" style="max-width: 100%; height: auto;">
        </async-img>
        <br/>
        <div style="display: flex; flex-direction: row;">
            <label style="font-weight: 500;">
                Reason: 
            </label>
            <p>
                {{details.issueDescription}}
            </p>
        </div>
      </ng-container>

  </div>
</div>